import { createReducer, on } from "@ngrx/store";
import { initialState } from "./shared.state";
import { setErrorMessage, setLoadingSpinner, setMenuExpand } from "./shared.actions";

export const sharedReducer = createReducer(
  initialState,
  on(setLoadingSpinner, (state, action) => {
    return {
      ...state,
      showLoading: action.status,
    }
  }),

  on(setMenuExpand, (state, { isExpand }) => {
    return {
      ...state, isExpand
    }
  }),
  on(setErrorMessage, (state, action) => {
    if (action.message) {
      return {
        ...state,
        errorMessage: { status: action.message?.status, message: action.message?.message },
      }
    } else {
      return {
        ...state,
        errorMessage: null
      }
    }
  }),
)
